// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-AttrLinked-AttrLinked-module__linkList--O5a2R {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fafafa;
  min-height: 32px;
  padding: 4px 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AttrLinked/AttrLinked.module.less"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;AACF","sourcesContent":[".linkList {\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background-color: #fafafa;\n  min-height: 32px;\n  padding: 4px 11px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"linkList": `src-components-AttrLinked-AttrLinked-module__linkList--O5a2R`
};
export default ___CSS_LOADER_EXPORT___;
